import React from "react";
import { Box, Grid, Link, Typography } from "@mui/material";
import { Trans } from "react-i18next/icu.macro";
import ChooseLanguage from "./ChooseLanguage";
export default function Footer() {
  return (
    <Box className="footer">
      {/*最底部 */}
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        style={{
          borderTop: "1px solid #E8E8E8",
          padding: "0 40px",
          background: "#ffffff",
          height: "240px",
        }}
      >
        <Grid
          item
          container
          direction={{
            xl: "row",
            xs: "column-reverse",
          }}
        >
          <Grid
            sx={{
              paddingLeft: "15px",
            }}
            item
            xl={7}
            md={2}
            sm={12}
            xs={12}
          >
            <Typography variant="caption" sx={{ whiteSpace: "nowrap" }}>
              <Trans i18nKey="All Rights Reserved © 8vs.com">All Rights Reserved © 8vs.com</Trans>
            </Typography>
          </Grid>
          <Box
            sx={{
              width: "100%",
              height: "1px",
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
              marginBottom: "10px",
            }}
          >
            <Box
              sx={{
                width: "90%",
                height: "1px",
                background: "#e4ebf3",
              }}
            ></Box>
          </Box>
          <Grid item xl={5} md={10}>
            <Grid
              container
              sx={{
                paddingLeft: { xl: "0", xs: "8px" },
              }}
            >
              <Grid item xl={3} lg={3} md={2} sm={6} xs={6}>
                <Link
                  id="link-bom"
                  underline="none"
                  href="/static/about.html"
                  onClick={() => {
                    sendConstructEventByEventParams("footer", {
                      click: "about_us",
                    });
                  }}
                  color="inherit"
                  sx={{
                    paddingLeft: { xs: "10px", lg: "10px" },
                    maxWidth: "95px",
                    height: "20px",
                    fontWeight: "500",
                    color: "#323339",
                    fontFamily: "Quicksand-Medium, Quicksand",
                    lineHeight: "20px",
                    "&:hover": { opacity: "0.6" },
                    textAlign: "left",
                  }}
                >
                  <Trans i18nKey="About US">About US</Trans>
                </Link>
              </Grid>
              <Grid item xl={3} lg={3} md={4} sm={6} xs={6}>
                <Link
                  underline="none"
                  href="/static/privacy.html"
                  onClick={() => {
                    sendConstructEventByEventParams("footer", {
                      click: "privacy",
                    });
                  }}
                  color="inherit"
                  sx={{
                    height: "20px",
                    fontFamily: "Quicksand-Medium, Quicksand",
                    fontWeight: "500",
                    color: " #323339",
                    lineHeight: "20px",
                    "&:hover": { opacity: "0.6" },
                  }}
                >
                  <Trans i18nKey="Privacy Policy">Privacy Policy</Trans>
                </Link>
              </Grid>
              <Grid item xl={4} lg={3} md={4} sm={6} xs={6}>
                <Link
                  underline="none"
                  href="/static/terms.html"
                  onClick={() => {
                    sendConstructEventByEventParams("footer", {
                      click: "terms",
                    });
                  }}
                  color="inherit"
                  // variant="span"
                  sx={{
                    paddingLeft: { xs: "10px", lg: "10px" },
                    maxWidth: "48px",
                    height: "20px",
                    fontFamily: "Quicksand-Medium, Quicksand",
                    fontWeight: "500",
                    color: "#323339",
                    lineHeight: "20px",
                    "&:hover": { opacity: "0.6" },
                  }}
                >
                  <Trans i18nKey="Terms of Service">Terms of Service</Trans>
                </Link>
              </Grid>
              <Grid item xl={2} lg={3} md={2} sm={6} xs={6}>
                {/* <ChooseLanguage /> */}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
